import WalkHeuguchon from "../../images/about/walk-heuguchon.gif"

import useHorizon from '../../hooks/useHorizon';

const AboutHeuguchon = () => {
    const slideInLeftShortAnimation = useHorizon({preset: 'slideInLeftShort', duration: '1000ms', threshold: 0.6});
    const slideInUpShortAnimation = useHorizon({preset: 'slideInUpShort', duration: '1000ms', delay: '300ms', threshold: 0.6});

    return (
        <div className="section-block feature-2 right">
            <div className="row flex">
                <div className="column width-6">
                    <div className="feature-image">
                        <div className="feature-image-inner center-on-mobile horizon"
                             {...slideInLeftShortAnimation}>
                            <img src={WalkHeuguchon} width="100" alt=""/>
                        </div>
                    </div>
                </div>
                <div className="column width-5 offset-1">
                    <div className="feature-content">
                        <div className="feature-content-inner left horizon"
                             {...slideInUpShortAnimation}>
                            <h2 className="mb-30">흑우촌은?</h2>
                            <p className="lead">흑우촌은 가상자산에 대해 소통하는 메타버스 기반의 커뮤니티입니다.</p>
                            <p>한 때 선풍적인 투자 열풍이 불었던 NFT는 현재 가격뿐만 아니라 거래량마저 줄어들고 있습니다.
                                이는 시장이 성숙해져서 그런것일수도 있겠지만,
                                실적이 저조하거나 애초부터 SCAM으로 진행 의지가 없는 프로젝트들이
                                시장에서 판을치고 있어 가격방어가 안되는 경우가 부지기수입니다.
                            </p>
                            <p>
                                심지어 NFT와 메타버스를 결합한 프로젝트들이 투자만 유치하고 개발을 하나도 하지 않는 상황을 보면서,
                                이를 꼬집으면서도 그나마 지금까지 발행된 NFT들의 쓰임새를 찾고자 메타버스 공간을 준비했습니다.
                            </p>
                            <div className="row">
                                <div className="column width-6">
                                    <h4 className="color-pink">하지 않겠습니다</h4>
                                    <p>흑우촌은 한탕 목적을 위한 자금 모집을 하지 않겠습니다.</p>
                                </div>
                                <div className="column width-6">
                                    <h4 className="color-green">하겠습니다</h4>
                                    <p>흑우촌은 실제 필요한 분야에 기술을 접목해서, Web3와 메타버스 발전에 기여하겠습니다.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutHeuguchon;